<template>
<v-layout row align-center justify-center>
  <v-flex xs12 md10 lg8 xl6>
    <v-form @submit.prevent="onSubmit">
      <input
        type="file"
        style="display: none"
        ref="image"
        accept="image/*"
        @change="onFilePicked"
      >
      <v-layout row>
        <v-flex>
          <v-card color="white">
            <v-layout pa-2>
              <v-flex class="text-xs-center title" align-self-center>
                Coloque seus dados para mais informações!
              </v-flex>
              <v-menu bottom left>
                <template v-slot:activator="{ on }">
                  <v-btn
                    class="mt-0"
                    icon
                    v-on="on"
                  >
                    <v-icon>more_vert</v-icon>
                  </v-btn>
                </template>

                <v-list>
                  <v-list-tile @click="showSalesman = true">
                    <v-list-tile-title>Adicionar representante</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </v-layout>
            <v-card-text class="pt-0">
              <v-layout justify-center>
                  <v-flex xs6 sm3 md4 lg3>
                      <v-img :src="require('../assets/SpLogo.png')"></v-img>
                  </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 sm6>
                  <v-layout row>
                    <v-flex>
                      <span class="error--text">{{error}}</span>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex>
                      <v-text-field label="Nome da sua loja" v-model="restaurantname"
                        browser-autocomplete="none" 
                        required data-vv-name="restaurantname"
                        v-validate="'required|max:80'" 
                        :error-messages="errors.collect('restaurantname')">
                      </v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex>
                        <v-autocomplete
                            v-model="tag"
                            :items="tags"
                            return-object
                            item-text="tag"
                            label="Escolha sua categoria"
                            required data-vv-name="tag"
                            v-validate="'required'" 
                            :error-messages="errors.collect('tag')"
                        >
                        </v-autocomplete>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex xs3 sm2>
                      <v-select label="UF" v-model="state" :items="states"
                        item-value="_id" item-text="sigla" @change="loadCities"
                        required data-vv-name="state"
                        v-validate="'required'" 
                        :error-messages="errors.collect('state')">
                      </v-select>
                    </v-flex>
                    <v-flex>
                      <v-autocomplete v-model="city" :items="cities" item-value="_id" item-text="nome"
                        label="Cidade" :loading="loadingUF" browser-autocomplete="none" :disabled="state==null"
                        required data-vv-name="city" :filter="filter"
                        v-validate="'required'" 
                        :error-messages="errors.collect('city')">
                      </v-autocomplete>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex>
                      <v-text-field label="Seu nome" v-model="managername"
                        required data-vv-name="name"
                        v-validate="'required'" 
                        :error-messages="errors.collect('name')">
                      </v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex>
                      <v-text-field label="Seu WhatsApp" v-model="phone" name="phone"
                        required data-vv-name="phone"
                        v-validate="'required|min:10|max:11'" 
                        :error-messages="errors.collect('phone')"
                        mask="(##) #####-####" type="tel">
                      </v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row v-if="showSalesman">
                    <v-flex xs5>
                      <v-text-field label="Representante" v-model="code"
                        browser-autocomplete="none" 
                        required data-vv-name="salesman"
                        v-validate="'max:3|min:3|numeric'" :readonly="salesman != null"
                        :error-messages="errors.collect('salesman')" maxLength="3" clearable>
                      </v-text-field>
                    </v-flex>
                    <v-flex>
                      <v-text-field disabled v-model="salesman.name" v-if="salesman"></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 sm6 pl-2>
                  <v-layout column fill-height>
                    <v-layout row justify-center align-center>
                        <v-flex xs10 sm8>
                            <v-img :src="(imageUrl)?imageUrl:require('../assets/photo_white.png')" 
                                width="100%" class="grey lighten-2" aspect-ratio="1" contain>
                                <v-container fill-height fluid pa-0 pb-4>
                                    <v-layout row align-center v-if="!imageUrl" pb-4>
                                        <v-flex class="text-xs-center">
                                            <v-btn class="sp-transparent" dark @click="pickFile">
                                                Sua Logomarca aqui
                                            </v-btn>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row wrap v-else align-center>
                                        <v-flex class="text-xs-center">
                                            <v-btn block class="sp-transparent" dark @click="pickFile" pb-4>
                                                Alterar imagem
                                            </v-btn>
                                            <v-btn block class="sp-transparent-red" dark @click="clearImage">
                                                Remover
                                            </v-btn>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-img>
                            <span class="body-1 grey--text lighten-1">Imagem quadrada. Formato JPEG ou JPG. Máx: 500KB</span>
                        </v-flex>
                    </v-layout>
                    <v-layout row justify-center>
                      <v-flex xs8 sm7 md6 lg6 xl6 v-bind:class="{'px-3':$vuetify.breakpoint.xlOnly}">
                        <v-radio-group 
                          v-model="ifood" 
                          row
                          required data-vv-name="ifood"
                          v-validate="'required'" 
                          :error-messages="errors.collect('ifood')"
                        >
                          <template slot="label">
                            <span class="pb-2">A sua loja está no iFood?</span>
                          </template>
                          <v-radio
                            label="Sim"
                            :value="true"
                          ></v-radio>
                          <v-spacer></v-spacer>
                          <v-radio
                            label="Não"
                            :value="false"
                          ></v-radio>
                        </v-radio-group>
                      </v-flex>
                    </v-layout>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions class="row wrap justify-center layout">
                <v-btn flat @click="$router.push({name:'Login'})">
                  Acessar a conta
                </v-btn>
                <v-btn color="success" type="submit" :loading="loading" :disabled="loading">
                  Confirmar
                </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>
  </v-flex>
</v-layout>
</template>

<script>
import { mapGetters } from 'vuex';
import store from '../store/index'

export default {
    $_veeValidate: {
        validator: 'new'
    },
    data(){
        return{
            ifood:null,
            loadingUF:false,
            city:null,
            state:null,
            managername:'',
            photo: '',
            password:'123456',
            restaurantname:'',
            phone:'',
            loading:false,
            error:null,
            tag:null,
            imageUrl: '',
            showSalesman:false,
            salesman:null,
            code:null
        }
    },
    async beforeRouteEnter(to,from,next){
      if(store.state.token)
        next({name:'AllProducts'})
      else{
        await store.dispatch('getStates')
        await store.dispatch('getTags')
        next()
      }
    },
    mounted(){
      if(this.$route.query.code){
        this.showSalesman = true
        setTimeout(() => {
          this.code = this.$route.query.code
        }, 200);
      }
    },
    computed:{
        ...mapGetters([
            'cities',
            'states',
            'tags'
        ]),
        email(){
          return `suporte@${this.phone}.com`
        }
    },
    watch:{
      async code(v){
        if(!v){
          this.salesman = null
          return
        }
        let valid = await this.$validator.validate('salesman')
        if(valid){
          try {
            const res = await this.$store.dispatch("getSalesman", this.code)
            if(res.data.ok){
              this.salesman = res.data.data
            }else{
              this.errors.add({field:"salesman",msg:res.data.error});
              this.salesman = null
            }
          } catch (error) {
            this.errors.add({field:"salesman",msg:error}); 
            this.salesman = null
          }
        }
      }
    },
    methods:{
      pickFile(){
        this.$refs.image.click()
      },
      teste(){
        alert("captei")
      },
      onFilePicked (e) {
        const files = e.target.files
        if(files[0] !== undefined) {				
          if(files[0].name.lastIndexOf('.') <= 0) {
            return
          }
          const fr = new FileReader ()
          fr.readAsDataURL(files[0])
          fr.addEventListener('load', () => {
            this.imageUrl = fr.result
            this.photo = fr.result // this is an image file that can be sent to server...
          })
        } else {
          this.clearImage()
        }
      },
      clearImage(){
          this.photo = ''
          this.imageUrl = ''
          this.$refs.image.value = ""
      },
      filter(item, queryText, itemText){
          return item.value.toLocaleLowerCase()
          .indexOf(this.replaceSpecialChars(queryText.toLocaleLowerCase())) > -1
      },
      replaceSpecialChars(str)
      {
          str = str.replace(/[ÀÁÂÃ]/,"A");
          str = str.replace(/[àáâã]/,"a");
          str = str.replace(/[ÈÉÊẼ]/,"E");
          str = str.replace(/[èéêẽ]/,"e");
          str = str.replace(/[ÌÍÎĨ]/,"I");
          str = str.replace(/[ìíîĩ]/,"i");
          str = str.replace(/[ÒÓÔÕ]/,"O");
          str = str.replace(/[òóôõ]/,"o");
          str = str.replace(/[ÙÚÛŨ]/,"U");
          str = str.replace(/[ùúûũ]/,"u");
          str = str.replace(/[Ç]/,"C");
          str = str.replace(/[ç]/,"c");

          return str.replace(/[^a-z0-9]/gi,''); 
      },
      clear(){
        this.ifood = null
        this.city = null
        this.state = null
        this.managername = ''
        this.password = ''
        this.email = ''
        this.restaurantname = ''
        this.phone=""
        this.clearImage()
        this.$validator.reset()
      },
      makeMessage(){
        const city = this.cities.find(v=>v._id==this.city).nome
        const state = this.states.find(v=>v._id==this.state).sigla
        const address = `${city}/${state}`
        const ifood = (this.ifood)?"":"não"
        let message = `Olá!\nSou ${this.managername} da loja ${this.restaurantname} em ${address} e ${ifood} estou no iFood.${"\n"
        }Já comecei a criar minha loja e gostaria de mais informações.`
        if(this.showSalesman && this.salesman){
          message += `${this.salesman.name} (${this.salesman.code})` 
        }
        return `https://api.whatsapp.com/send?phone=5531995093600&text=${encodeURI(message)}`
      },
      async onSubmit(){
        try {
            this.loading = true
            let valid = await this.$validator.validateAll()
            
            if(valid){
                let {city,state,managername,password,email,restaurantname,tag,phone,ifood} = this
                const data = {
                    city,state,managername,password,email,restaurantname,tag,phone,ifood
                }
                if(this.photo != ""){
                  data.photo = this.photo
                }
                if(this.showSalesman && this.salesman){
                  data.salesman = this.salesman._id
                }
                let res = await this.$store.dispatch('createRestaurant',data)
                if(!res.ok){
                    this.error = res.error
                }else{
                    this.error = null
                    const win = window.open(this.makeMessage(), '_blank')
                    this.$router.push({name:'AllProducts'})
                }
                this.loading = false
            }
          } catch (error) {
              console.log(error);
              this.error = "Algo inesperado aconteceu."
          } finally {
            this.loading = false
          }
      },
      async loadCities(){
        if(!this.state)return

        this.loadingUF = true
        await this.$store.dispatch('getCities',this.state)
        this.loadingUF = false
      }
    }

}
</script>

<style>

</style>